import { useTranslation } from 'react-i18next';
import { formatCurrencyWithDecimals, formatDateShort } from '@utriper/core';
import { Card, CardContent, Box, Typography, Button, IconButton, Link, alpha, FormHelperText } from '@mui/material';
import { DeleteOutline } from '@mui/icons-material';
import { useMemo } from 'react';

const ExperienceCard = ({ title, option, date, peopleLabel, total, currency, onEdit, onDelete, onOpenDetails, errors }) => {
    const { i18n } = useTranslation();
    const hasErrors = useMemo(() => Object.values(errors || {})?.length > 0, [errors]);

    return (
        <Card
            variant="outlined"
            sx={{
                borderRadius: 2,
                boxSizing: 'border-box',
                width: '100%',
                border: hasErrors ? '1px solid #C51313' : '1px solid rgba(0, 0, 0, 0.12)',
            }}
        >
            <CardContent sx={{ p: 2 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="subtitle1" fontWeight={600} noWrap sx={{ color: hasErrors ? '#C51313' : '#131313' }}>
                        {title} {option ? `(${option?.description1})` : ''}
                    </Typography>

                    <Button size="small" onClick={onEdit} sx={{ textTransform: 'none', fontWeight: 600 }}>
                        Editar
                    </Button>
                </Box>

                {errors && hasErrors && (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                        {Object.values(errors).map((error, index) => (
                            <FormHelperText
                                key={`${error}-${index}`}
                                error
                                sx={{
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                }}
                            >
                                {error}
                            </FormHelperText>
                        ))}
                    </Box>
                )}

                <Box mt={1}>
                    {date && (
                        <Typography variant="body2" color="text.secondary">
                            📅 {formatDateShort(date, i18n.language)}
                        </Typography>
                    )}

                    <Typography variant="body2" color="text.secondary">
                        👥 {peopleLabel}
                    </Typography>
                </Box>

                <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
                    <Box display="flex" gap={1}>
                        <Typography variant="subtitle2" fontWeight={600}>
                            {formatCurrencyWithDecimals(total, currency, i18n.language, 0)}
                        </Typography>
                        {total > 0 && (
                            <Link
                                component="button"
                                onClick={onOpenDetails}
                                sx={{
                                    width: '100%',
                                    textAlign: 'end',
                                    color: alpha('#131313', 0.75),
                                    fontSize: '14px',
                                    fontWeight: 600,
                                }}
                            >
                                Ver detalles
                            </Link>
                        )}
                    </Box>

                    <IconButton size="small" onClick={onDelete}>
                        <DeleteOutline color="error" fontSize="small" />
                    </IconButton>
                </Box>
            </CardContent>
        </Card>
    );
};

export default ExperienceCard;
